export const apiConstants = {
  url: "/api/company",
  labeltypes: "/api/labeltype"
};
